'use client'

import type { PropsWithChildren } from 'react'

import { ThemeProvider as NextThemesProvider } from 'next-themes'

/**
 * @param nonce - Optional CSP nonce. When provided, next-themes stamps it on
 *   the inline FOUC script + style elements it injects. Required under an
 *   enforced `script-src 'nonce-…' 'strict-dynamic'` policy — without it, the
 *   inline boot script is refused and themes flash on first paint.
 */
export function ThemeProvider({ children, nonce }: PropsWithChildren<{ nonce?: string }>) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      nonce={nonce}
    >
      <div className="bg-background text-foreground">{children}</div>
    </NextThemesProvider>
  )
}
